import { m as Z, j as e, c as le, u as W } from "./index-MV41Sec8.js";
import {
  b as l,
  w as J,
  o as ie,
  p as ce,
  D as de,
  S as pe,
  T as xe,
  y as V,
  X as z,
  n as I,
  j as Y,
  E as he,
} from "./vendor-MV119.js";
import "./qrcode-DpynCwP9.js";
const mvThumbs = (p) => {
  if (
    typeof p !== "string" ||
    !/^\/uploads\/(deals|real-images)\/[^?#\s,]+\.(jpe?g|png|webp|gif)$/i.test(
      p,
    )
  )
    return;
  const r = p.slice(9);
  return `/uploads/thumbs/w128/${r}.webp 128w, /uploads/thumbs/w192/${r}.webp 192w`;
};
function ke({
  language: q,
  refreshKey: G,
  onLockRotation: j,
  onNextWidget: L,
  onPrevWidget: T,
  mvSeeJust: mvSJ,
}) {
  const [d, _] = l.useState([]),
    [H, F] = l.useState(!0),
    [i, f] = l.useState(mvSJ ? "all" : "walmart"),
    [x, X] = l.useState(!!mvSJ),
    [$, ue] = l.useState("1x10"),
    [K, C] = l.useState(1),
    [U, A] = l.useState(null),
    [Q, S] = l.useState(!1),
    [c, w] = l.useState(null),
    [ee, D] = l.useState({}),
    [me, be] = l.useState(null),
    [ge, fe] = l.useState(""),
    r = q === "ar",
    te = (t) => {
      if (
        (t && t.preventDefault(),
        !d.some((o) => o.is_shortened || !!o.custom_short_link))
      ) {
        S(!0);
        return;
      }
      window.location.href = `/api/deals/export-zip${x ? "?onlyVisitor=true" : ""}`;
    },
    R = async () => {
      F(!0);
      try {
        const t = new URLSearchParams();
        (i !== "all" && t.append("store", i),
          x && t.append("seeJustYourDeals", "true"),
          t.append("source", "deals"));
        const s = await fetch(`/api/deals?${t.toString()}`);
        if (!s.ok) throw new Error("Failed to fetch deals");
        const o = await s.json();
        o.success && Array.isArray(o.deals) && _(o.deals);
      } catch (t) {
        console.error("Error fetching deals:", t);
      } finally {
        F(!1);
      }
    };
  l.useEffect(() => {
    R();
    const t = () => {
      R();
    };
    return (
      window.addEventListener("sh_link_shortened", t),
      () => window.removeEventListener("sh_link_shortened", t)
    );
  }, [i, x, G]);
  const se = (t) => {
      w(t);
      const s = le(t);
      W(`/deal-preview/${s}`, t.description);
    },
    O = () => {
      (w(null), W("/deals"));
    };
  (l.useEffect(() => {
    if (mvSJ || !d.length) return;
    const t = window.location.pathname;
    if (
      t.startsWith("/deal-preview/") ||
      (t.startsWith("/deals/") && t !== "/deals")
    ) {
      const s = t.replace(/^\/(deal-preview|deals)\//, "");
      if (s) {
        const o = Z(s, d);
        o && w(o);
      }
    }
  }, [d]),
    l.useEffect(() => {
      const t = () => {
        const s = window.location.pathname;
        if (
          !mvSJ &&
          (s.startsWith("/deal-preview/") ||
            (s.startsWith("/deals/") && s !== "/deals"))
        ) {
          const o = s.replace(/^\/(deal-preview|deals)\//, "");
          if (o && d.length > 0) {
            const a = Z(o, d);
            if (a) {
              w(a);
              return;
            }
          }
        }
        w(null);
      };
      return (
        window.addEventListener("popstate", t),
        () => window.removeEventListener("popstate", t)
      );
    }, [d]));
  const u = (t) => {
      (A(t),
        setTimeout(() => {
          A(null);
        }, 2500));
    },
    b = async (t, s) => {
      if (
        (s === "description" || s === "image" || s === "post") &&
        !(t.is_shortened && t.custom_short_link)
      ) {
        (D((a) => ({ ...a, [t.id]: !0 })),
          setTimeout(() => {
            D((a) => ({ ...a, [t.id]: !1 }));
          }, 3500));
        return;
      }
      let o = "";
      if (s === "description") o = t.description;
      else if (s === "comment")
        o =
          t.is_shortened && t.custom_short_link
            ? t.custom_short_link
            : t.comment_link;
      else if (s === "post") {
        const a =
          t.is_shortened && t.custom_short_link
            ? t.custom_short_link
            : t.comment_link;
        o = `${t.description}

${a}`;
      }
      if (s === "image")
        try {
          if (
            (u(r ? "جاري نسخ الصورة..." : "Copying image to clipboard..."),
            navigator.clipboard && window.ClipboardItem)
          ) {
            const a = (async () => {
              const n = `/api/proxy-image?url=${encodeURIComponent(t.image_path)}`,
                p = await fetch(n);
              if (!p.ok) throw new Error("Proxy fetch failed");
              const m = await p.blob();
              return new Promise((ne, E) => {
                const h = new Image(),
                  y = URL.createObjectURL(m);
                ((h.onload = () => {
                  const g = document.createElement("canvas");
                  ((g.width = h.naturalWidth || h.width || 400),
                    (g.height = h.naturalHeight || h.height || 400));
                  const N = g.getContext("2d");
                  N
                    ? ((N.fillStyle = "#FFFFFF"),
                      N.fillRect(0, 0, g.width, g.height),
                      N.drawImage(h, 0, 0),
                      g.toBlob(
                        (M) => {
                          (URL.revokeObjectURL(y),
                            M ? ne(M) : E(new Error("Canvas toBlob failed")));
                        },
                        "image/png",
                        1,
                      ))
                    : (URL.revokeObjectURL(y),
                      E(new Error("No canvas context")));
                }),
                  (h.onerror = () => {
                    (URL.revokeObjectURL(y),
                      E(new Error("Image render failed")));
                  }),
                  (h.src = y));
              });
            })();
            (await navigator.clipboard.write([
              new ClipboardItem({ "image/png": a }),
            ]),
              u(
                r
                  ? "تم نسخ الصورة! يمكنك لصقها مباشرة في فيسبوك (Ctrl+V) ✓"
                  : "Image copied! Ready to paste directly into Facebook (Ctrl+V) ✓",
              ));
          } else throw new Error("Clipboard API unsupported");
        } catch (a) {
          console.error(
            "Direct image copy failed, downloading file fallback:",
            a,
          );
          try {
            const n = document.createElement("a");
            ((n.href = t.image_path),
              (n.download = `deal_image_${t.id}.jpg`),
              (n.target = "_blank"),
              document.body.appendChild(n),
              n.click(),
              document.body.removeChild(n),
              u(
                r
                  ? "تم تحميل الصورة إلى جهازك! يمكنك رفعها في فيسبوك ✓"
                  : "Downloaded image file! Upload it directly to Facebook ✓",
              ));
          } catch {
            u(r ? "فشل نسخ الصورة" : "Failed to copy image");
          }
        }
      else
        try {
          (await navigator.clipboard.writeText(o),
            u(
              s === "description"
                ? r
                  ? "تم نسخ الوصف! ✓"
                  : "Copied description! ✓"
                : s === "comment"
                  ? r
                    ? "تم نسخ الرابط! ✓"
                    : "Copied link! ✓"
                  : r
                    ? "تم نسخ المنشور كامل! ✓"
                    : "Copied full post! ✓",
            ));
        } catch {
          u(r ? "فشل النسخ" : "Failed to copy");
        }
      try {
        const a = await fetch(`/api/deals/${t.id}/copy`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ field: s }),
        });
        if (a.ok) {
          const n = await a.json();
          n.success &&
            typeof n.copy_count == "number" &&
            _((p) =>
              p.map((m) =>
                m.id === t.id ? { ...m, copy_count: n.copy_count } : m,
              ),
            );
        }
      } catch (a) {
        console.error("Error recording copy:", a);
      }
    },
    re = async (t) => {
      try {
        (
          await fetch(`/api/deals/${t}/override`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ is_deleted: !0 }),
          })
        ).ok &&
          (_((o) => o.filter((a) => a.id !== t)),
          u(
            r
              ? "تم إخفاء العرض لهذا الجهاز ✓"
              : "Deal hidden for your device ✓",
          ));
      } catch (s) {
        console.error("Error hiding deal:", s);
      }
    },
    P = $ === "1x10" ? 10 : $ === "2x10" ? 20 : 30,
    k = Math.max(1, Math.ceil(d.length / P)),
    v = Math.min(K, k),
    B = (v - 1) * P,
    oe = d.slice(B, B + P),
    ae = (t, s) => {
      if (s <= 7) return Array.from({ length: s }, (p, m) => m + 1);
      const o = [];
      (o.push(1), t > 3 && o.push("..."));
      const a = Math.max(2, t - 1),
        n = Math.min(s - 1, t + 1);
      for (let p = a; p <= n; p++) o.push(p);
      return (t < s - 2 && o.push("..."), o.push(s), o);
    };
  return e.jsxs("div", {
    className:
      "bg-[#0b132b] border border-slate-700/60 rounded-2xl p-3.5 sm:p-4 shadow-xl text-white w-full font-sans select-none relative overflow-hidden",
    children: [
      U &&
        e.jsx("div", {
          className:
            "absolute top-2 left-1/2 -translate-x-1/2 z-50 bg-purple-600 text-white text-xs font-extrabold px-4 py-2 rounded-full shadow-lg border border-purple-400 animate-bounce",
          children: U,
        }),
      e.jsxs("div", {
        className:
          "flex items-center justify-between pb-2.5 border-b border-slate-800 mb-3",
        children: [
          e.jsxs("div", {
            className: "flex items-center gap-2",
            children: [
              e.jsx(J, { className: "w-4 h-4 text-indigo-400 animate-pulse" }),
              e.jsx("h2", {
                className:
                  "text-xs sm:text-sm font-black text-white tracking-wider uppercase",
                children: r ? "عروض المنتجات المميزة" : "DEALS LIST",
              }),
              e.jsxs("span", {
                className:
                  "text-[10px] font-mono font-extrabold px-2 py-0.5 bg-indigo-950 text-indigo-300 border border-indigo-900 rounded-full",
                children: [d.length, " Deals"],
              }),
            ],
          }),
          e.jsxs("div", {
            className: "flex items-center gap-1",
            children: [
              T &&
                e.jsx("button", {
                  onClick: () => {
                    (j && j(), T());
                  },
                  title: "Previous Widget",
                  className:
                    "p-1 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 transition-colors cursor-pointer",
                  children: e.jsx(ie, { size: 14 }),
                }),
              L &&
                e.jsx("button", {
                  onClick: () => {
                    (j && j(), L());
                  },
                  title: "Next Widget",
                  className:
                    "p-1 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 transition-colors cursor-pointer",
                  children: e.jsx(ce, { size: 14 }),
                }),
            ],
          }),
        ],
      }),
      e.jsx("div", {
        className:
          "flex flex-wrap items-center justify-between gap-2 pb-2 mb-2.5",
        children: e.jsxs("div", {
          className:
            "flex items-center gap-2 overflow-x-auto scrollbar-none py-1",
          children: [
            e.jsx("button", {
              onClick: () => f(i === "walmart" ? "all" : "walmart"),
              className: `px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${i === "walmart" ? "bg-blue-600 text-white shadow-md shadow-blue-900/50 ring-2 ring-blue-300" : "bg-blue-600/90 hover:bg-blue-600 text-white"}`,
              children: "Walmart",
            }),
            e.jsx("button", {
              onClick: () => f(i === "amazon" ? "all" : "amazon"),
              className: `px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${i === "amazon" ? "bg-amber-500 text-slate-950 shadow-md shadow-amber-900/50 ring-2 ring-amber-300" : "bg-amber-500/90 hover:bg-amber-500 text-slate-950"}`,
              children: "Amazon",
            }),
            e.jsx("button", {
              onClick: () => f(i === "aliexpress" ? "all" : "aliexpress"),
              className: `px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${i === "aliexpress" ? "bg-rose-600 text-white shadow-md shadow-rose-900/50 ring-2 ring-rose-300" : "bg-rose-600/90 hover:bg-rose-600 text-white"}`,
              children: "AliExpress",
            }),
            e.jsx("button", {
              onClick: () => f(i === "other" ? "all" : "other"),
              className: `px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${i === "other" ? "bg-purple-800 text-white shadow-md ring-2 ring-purple-300" : "bg-purple-900/80 hover:bg-purple-800 text-purple-200 border border-purple-500/40"}`,
              children: r ? "أخرى" : "Other",
            }),
            i !== "all" &&
              e.jsx("button", {
                onClick: () => f("all"),
                className:
                  "px-2.5 py-1 rounded-lg text-xs font-bold text-white bg-black/20 hover:bg-black/40 underline transition-colors cursor-pointer",
                children: r ? "إلغاء التصفية" : "Show All",
              }),
          ],
        }),
      }),
      e.jsxs("div", {
        className:
          "flex flex-wrap items-center justify-between gap-2 bg-black/20 p-2 rounded-2xl border border-white/20 mb-3 backdrop-blur-sm",
        children: [
          e.jsxs("label", {
            className: "flex items-center gap-2 cursor-pointer select-none",
            children: [
              e.jsx("input", {
                type: "checkbox",
                checked: x,
                onChange: (t) => X(t.target.checked),
                className:
                  "w-5 h-5 rounded-md border-2 border-white/80 text-[var(--blue)] bg-white/20 focus:ring-2 focus:ring-white cursor-pointer",
              }),
              e.jsx("span", {
                className:
                  "bg-[var(--blue-d)] hover:brightness-110 text-white font-black text-xs px-3 py-1.5 rounded-xl tracking-wider uppercase shadow-md transition-colors border border-white/20",
                children: r ? "عروضي المحددة" : "My Selected Deals",
              }),
            ],
          }),
          e.jsxs("button", {
            onClick: te,
            disabled: !x,
            className: `px-3.5 py-1.5 rounded-xl text-xs font-black flex items-center gap-1.5 transition-all shadow-md shrink-0 border border-white/20 ${x ? "bg-emerald-700 hover:bg-emerald-600 text-white cursor-pointer active:scale-95 shadow-lg" : "bg-white/10 text-white/50 opacity-60 cursor-not-allowed"}`,
            title: x
              ? r
                ? "تحميل العروض كملف ZIP"
                : "Download ZIP"
              : r
                ? "قم بتفعيل 'عروضي المحددة' أولاً للتحميل"
                : "Enable 'My Selected Deals' first to download",
            children: [
              e.jsx(de, { size: 14 }),
              e.jsx("span", { children: r ? "تحميل ZIP" : "Download ZIP" }),
            ],
          }),
        ],
      }),
      e.jsx("div", {
        className:
          "max-h-[440px] overflow-y-auto pr-1 custom-scrollbar grid grid-cols-1 gap-2.5",
        children: H
          ? e.jsxs("div", {
              className:
                "py-12 col-span-full text-center text-white/80 flex flex-col items-center justify-center gap-2",
              children: [
                e.jsx("div", {
                  className:
                    "w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin",
                }),
                e.jsx("span", {
                  className: "text-xs font-bold",
                  children: r ? "جاري تحميل العروض..." : "Loading deals...",
                }),
              ],
            })
          : d.length === 0
            ? e.jsxs("div", {
                className:
                  "py-12 col-span-full text-center text-white/80 bg-black/20 rounded-2xl border border-dashed border-white/30 p-6",
                children: [
                  e.jsx(pe, {
                    className: "w-8 h-8 text-white/60 mx-auto mb-2",
                  }),
                  e.jsx("p", {
                    className: "text-xs font-bold text-white",
                    children: x
                      ? r
                        ? "لم تقم بتخصيص أي عروض بعد."
                        : "No custom deals found for your IP."
                      : r
                        ? "لا توجد عروض متاحة حالياً."
                        : "No deal posts published yet.",
                  }),
                ],
              })
            : oe.map((t, mvI) =>
                e.jsxs(
                  "div",
                  {
                    className: "flex items-center gap-2 min-w-0",
                    children: [
                      e.jsx("button", {
                        onClick: () => re(t.id),
                        title: r ? "إخفاء العرض لهذا الجهاز" : "Hide for my IP",
                        className:
                          "bg-rose-600 hover:bg-rose-500 text-white p-2.5 rounded-xl cursor-pointer shrink-0 flex items-center justify-center shadow-md transition-transform active:scale-95",
                        children: e.jsx(xe, { size: 16 }),
                      }),
                      e.jsxs("div", {
                        className:
                          "flex-1 bg-[var(--card)] border border-[var(--line)] rounded-2xl p-2.5 flex items-center gap-2.5 shadow-[0_10px_24px_-12px_rgba(0,0,0,0.3)] min-w-0 text-[var(--ink)] relative",
                        children: [
                          ee[t.id] &&
                            e.jsxs("div", {
                              className:
                                "absolute inset-x-1.5 top-1.5 z-30 bg-amber-950/95 border border-amber-500/90 rounded-xl p-2 shadow-xl flex items-center justify-between gap-2 text-amber-200 text-[11px] font-semibold animate-in fade-in slide-in-from-top-1 duration-200",
                              children: [
                                e.jsxs("div", {
                                  className:
                                    "flex items-center gap-1.5 min-w-0 flex-1",
                                  children: [
                                    e.jsx(V, {
                                      className:
                                        "w-3.5 h-3.5 text-amber-400 shrink-0",
                                    }),
                                    e.jsx("span", {
                                      className: "leading-tight",
                                      children: r
                                        ? "يجب اختصار الرابط أولاً قبل كتابة أو نسخ الوصف أو الصورة."
                                        : "You must shorten the link first before you can copy the description or image.",
                                    }),
                                  ],
                                }),
                                e.jsx("button", {
                                  onClick: (s) => {
                                    (s.stopPropagation(),
                                      D((o) => ({ ...o, [t.id]: !1 })));
                                  },
                                  className:
                                    "text-amber-400 hover:text-white p-0.5 rounded cursor-pointer shrink-0",
                                  children: e.jsx(z, {
                                    className: "w-3.5 h-3.5",
                                  }),
                                }),
                              ],
                            }),
                          e.jsxs("button", {
                            onClick: () => b(t, "image"),
                            title: r
                              ? "انقر لنسخ الصورة (لصق مباشر في فيسبوك) أو اسحبها"
                              : "Click to copy image (paste into Facebook) or drag & drop",
                            className:
                              "w-16 h-16 rounded-xl bg-slate-900 overflow-hidden shrink-0 border border-[var(--line)] relative group cursor-pointer shadow-sm",
                            children: [
                              e.jsx("img", {
                                src: t.image_path,
                                srcSet: mvThumbs(t.image_path),
                                sizes: "64px",
                                width: 64,
                                height: 64,
                                loading: mvI < 4 ? "eager" : "lazy",
                                decoding: "async",
                                alt: "Deal product",
                                draggable: !0,
                                onDragStart: (s) => {
                                  (s.dataTransfer.setData(
                                    "text/plain",
                                    window.location.origin + t.image_path,
                                  ),
                                    s.dataTransfer.setData(
                                      "text/uri-list",
                                      window.location.origin + t.image_path,
                                    ));
                                },
                                className:
                                  "w-full h-full object-cover group-hover:scale-105 transition-transform",
                                onError: (s) => {
                                  const o = s.currentTarget;
                                  if (o.getAttribute("srcset")) {
                                    o.removeAttribute("srcset");
                                    return;
                                  }
                                  o.src.includes("default.jpg") ||
                                    (o.src = "/uploads/deals/default.jpg");
                                },
                              }),
                              e.jsx("div", {
                                className:
                                  "absolute inset-0 bg-purple-900/70 opacity-0 group-hover:opacity-100 flex items-center justify-center text-[10px] font-black text-white transition-opacity uppercase tracking-wider",
                                children: r ? "نسخ" : "Copy",
                              }),
                            ],
                          }),
                          e.jsxs("div", {
                            className: "flex-1 min-w-0 flex flex-col gap-1.5",
                            children: [
                              e.jsxs("div", {
                                onClick: () => b(t, "description"),
                                title: r
                                  ? "انقر في أي مكان لنسخ الوصف"
                                  : "Click anywhere to copy description",
                                className:
                                  "bg-[var(--bg-soft)] hover:bg-[var(--bg-tint)] rounded-xl p-2 flex items-center justify-between gap-2 border border-[var(--line)] hover:border-[var(--blue)]/50 text-xs cursor-pointer transition-all active:scale-[0.99] group/desc",
                                children: [
                                  e.jsx("p", {
                                    className:
                                      "line-clamp-2 text-[11px] font-bold leading-snug text-[var(--ink)] flex-1 min-w-0",
                                    children: t.description,
                                  }),
                                  e.jsx("button", {
                                    type: "button",
                                    onClick: (s) => {
                                      (s.stopPropagation(),
                                        b(t, "description"));
                                    },
                                    title: r ? "نسخ الوصف" : "Copy description",
                                    className:
                                      "p-1 text-[var(--slate)] group-hover/desc:text-white bg-[var(--bg-tint)] group-hover/desc:bg-purple-600 rounded-lg shrink-0 transition-colors cursor-pointer",
                                    children: e.jsx(I, { size: 13 }),
                                  }),
                                ],
                              }),
                              e.jsxs("div", {
                                onClick: () => b(t, "comment"),
                                title: r
                                  ? "انقر في أي مكان لنسخ الرابط"
                                  : "Click anywhere to copy link",
                                className: `rounded-xl p-2 flex items-center justify-between gap-2 text-xs font-bold transition-all cursor-pointer active:scale-[0.99] group/link ${t.is_shortened ? "bg-[#22c55e] hover:bg-[#16a34a] border border-green-500 text-slate-950 shadow-md" : "bg-[var(--bg-soft)] hover:bg-[var(--bg-tint)] border border-[var(--line)] hover:border-[var(--blue)]/50 text-blue-700"}`,
                                children: [
                                  e.jsxs("div", {
                                    className:
                                      "flex items-center gap-1.5 min-w-0 flex-1",
                                    children: [
                                      t.is_shortened &&
                                        e.jsx("span", {
                                          className:
                                            "bg-slate-950 text-emerald-400 text-[9px] font-black px-1.5 py-0.5 rounded uppercase tracking-wider shrink-0",
                                          children: "New shorten link",
                                        }),
                                      e.jsx("span", {
                                        className:
                                          "font-mono text-[11px] truncate block font-bold",
                                        children:
                                          t.is_shortened && t.custom_short_link
                                            ? t.custom_short_link
                                            : t.comment_link ||
                                              (r ? "لا يوجد رابط" : "No link"),
                                      }),
                                    ],
                                  }),
                                  e.jsx("button", {
                                    type: "button",
                                    onClick: (s) => {
                                      (s.stopPropagation(), b(t, "comment"));
                                    },
                                    title: r ? "نسخ الرابط" : "Copy link",
                                    className: `p-1 rounded-lg shrink-0 transition-colors cursor-pointer ${t.is_shortened ? "text-slate-950 group-hover/link:bg-black/20" : "text-[var(--slate)] group-hover/link:text-white bg-[var(--bg-tint)] group-hover/link:bg-purple-600"}`,
                                    children: e.jsx(I, { size: 13 }),
                                  }),
                                ],
                              }),
                            ],
                          }),
                          e.jsxs("button", {
                            onClick: () => se(t),
                            title: r ? "شاهد العرض" : "See this Deal",
                            className:
                              "bg-emerald-600 hover:bg-emerald-500 text-white text-[11px] font-black px-3 py-2.5 rounded-xl flex flex-col sm:flex-row items-center justify-center gap-1.5 shrink-0 shadow-md transition-all active:scale-95 cursor-pointer border border-emerald-400/40",
                            children: [
                              e.jsx(Y, { size: 15 }),
                              e.jsx("span", {
                                className: "whitespace-nowrap",
                                children: r ? "شاهد العرض" : "See Deal",
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  },
                  t.id,
                ),
              ),
      }),
      e.jsxs("div", {
        className:
          "flex items-center justify-between gap-1.5 border-t border-slate-800 pt-2.5 mt-2.5 text-xs",
        children: [
          e.jsxs("button", {
            onClick: () => C((t) => Math.max(1, t - 1)),
            disabled: v === 1,
            className:
              "px-2.5 py-1 bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed font-bold cursor-pointer transition-colors flex items-center gap-1 text-[11px]",
            children: ["‹ ", r ? "السابق" : "Back"],
          }),
          e.jsx("div", {
            className: "flex items-center gap-1 overflow-x-auto scrollbar-none",
            children: ae(v, k).map((t, s) =>
              typeof t == "number"
                ? e.jsx(
                    "button",
                    {
                      onClick: () => C(t),
                      className: `min-w-[26px] h-6 px-1.5 rounded-lg font-black text-[11px] cursor-pointer transition-all ${v === t ? "bg-indigo-600 text-white shadow-sm" : "bg-slate-800/80 text-slate-400 hover:text-white"}`,
                      children: t,
                    },
                    s,
                  )
                : e.jsx(
                    "span",
                    {
                      className: "text-slate-500 font-bold px-0.5 text-[10px]",
                      children: "...",
                    },
                    s,
                  ),
            ),
          }),
          e.jsxs("button", {
            onClick: () => C((t) => Math.min(k, t + 1)),
            disabled: v === k,
            className:
              "px-2.5 py-1 bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed font-bold cursor-pointer transition-colors flex items-center gap-1 text-[11px]",
            children: [r ? "التالي" : "Next", " ›"],
          }),
        ],
      }),
      c &&
        e.jsx("div", {
          className:
            "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200",
          children: e.jsxs("div", {
            className:
              "bg-[#182032] border-2 border-emerald-500/60 rounded-3xl p-5 max-w-lg w-full shadow-2xl flex flex-col gap-4 relative text-white",
            children: [
              e.jsx("button", {
                onClick: () => O(),
                className:
                  "absolute top-4 right-4 text-slate-400 hover:text-white p-1.5 rounded-xl bg-slate-800/80 hover:bg-slate-700 transition-colors cursor-pointer",
                children: e.jsx(z, { size: 18 }),
              }),
              e.jsxs("div", {
                className: "flex items-center gap-2.5",
                children: [
                  e.jsx("div", {
                    className:
                      "w-10 h-10 rounded-2xl bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 flex items-center justify-center shrink-0",
                    children: e.jsx(Y, { size: 20 }),
                  }),
                  e.jsxs("div", {
                    children: [
                      e.jsxs("h3", {
                        className:
                          "text-base font-black text-white flex items-center gap-2",
                        children: [
                          e.jsx("span", {
                            children: r ? "معاينة العرض" : "Deal Preview",
                          }),
                          e.jsx("span", {
                            className:
                              "text-[10px] uppercase font-bold px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-500/30",
                            children: c.store || "Deal",
                          }),
                        ],
                      }),
                      e.jsx("p", {
                        className: "text-[11px] text-slate-400",
                        children: r
                          ? "تفاصيل العرض والرابط المباشر"
                          : "Full deal details and direct affiliate link",
                      }),
                    ],
                  }),
                ],
              }),
              e.jsx("div", {
                className:
                  "relative w-full h-56 rounded-2xl bg-slate-900 border border-slate-700/80 overflow-hidden group flex items-center justify-center",
                children: e.jsx("img", {
                  src: c.image_path,
                  alt: c.description,
                  className: "w-full h-full object-contain p-2",
                  onError: (t) => {
                    t.target.src =
                      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=500&h=500&q=80";
                  },
                }),
              }),
              e.jsxs("div", {
                className:
                  "bg-slate-800/80 rounded-2xl p-3 border border-slate-700/80 text-xs font-semibold leading-relaxed text-slate-100 max-h-32 overflow-y-auto custom-scrollbar",
                children: [
                  e.jsx("p", {
                    className:
                      "text-[10px] uppercase font-black mb-1 text-emerald-400",
                    children: r ? "وصف العرض:" : "Deal Description:",
                  }),
                  c.description,
                ],
              }),
              e.jsxs("div", {
                className: "flex flex-col gap-1.5",
                children: [
                  e.jsx("p", {
                    className:
                      "text-[10px] uppercase font-black text-slate-400",
                    children: r
                      ? "رابط العرض المباشر:"
                      : "Original Affiliate Link:",
                  }),
                  e.jsxs("div", {
                    className:
                      "bg-slate-900 rounded-xl p-2.5 border border-slate-700 flex items-center justify-between gap-2",
                    children: [
                      e.jsx("span", {
                        className: "font-mono text-xs text-blue-300 truncate",
                        children:
                          c.custom_short_link ||
                          c.comment_link ||
                          (r ? "لا يوجد رابط" : "No link"),
                      }),
                      e.jsxs("button", {
                        onClick: () => b(c, "comment"),
                        className:
                          "px-3 py-1.5 bg-purple-600 hover:bg-purple-500 text-white rounded-lg text-xs font-bold flex items-center gap-1 transition-colors cursor-pointer shrink-0",
                        children: [
                          e.jsx(I, { size: 13 }),
                          e.jsx("span", { children: r ? "نسخ" : "Copy" }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              e.jsxs("div", {
                className:
                  "flex items-center gap-2 pt-2 border-t border-slate-800",
                children: [
                  (c.comment_link || c.custom_short_link) &&
                    e.jsxs("a", {
                      href: c.custom_short_link || c.comment_link,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      className:
                        "flex-1 py-2.5 px-4 bg-emerald-600 hover:bg-emerald-500 text-white font-black text-xs rounded-xl shadow-lg transition-all cursor-pointer flex items-center justify-center gap-2",
                      children: [
                        e.jsx(he, { size: 15 }),
                        e.jsx("span", {
                          children: r ? "زيارة رابط العرض" : "Visit Deal Page",
                        }),
                      ],
                    }),
                  e.jsx("button", {
                    onClick: () => O(),
                    className:
                      "py-2.5 px-4 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white font-bold text-xs rounded-xl transition-colors cursor-pointer",
                    children: r ? "إغلاق" : "Close",
                  }),
                ],
              }),
            ],
          }),
        }),
      Q &&
        e.jsx("div", {
          className:
            "fixed inset-0 z-50 bg-black/75 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200",
          children: e.jsxs("div", {
            className:
              "bg-[#1a2133] border-2 border-purple-500/60 rounded-2xl p-6 max-w-md w-full shadow-2xl flex flex-col items-center text-center relative",
            children: [
              e.jsx("button", {
                onClick: () => S(!1),
                className:
                  "absolute top-3 right-3 text-slate-400 hover:text-white p-1 rounded-lg transition-colors cursor-pointer",
                children: e.jsx(z, { size: 18 }),
              }),
              e.jsx("div", {
                className:
                  "w-12 h-12 rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/30 flex items-center justify-center mb-3",
                children: e.jsx(V, { size: 24 }),
              }),
              e.jsx("h3", {
                className: "text-lg font-black text-white mb-2",
                children: r
                  ? "تنبيه: يلزم تقصير رابط أولاً!"
                  : "Shorten Link Required First!",
              }),
              e.jsx("p", {
                className: "text-xs text-slate-300 leading-relaxed mb-6",
                children: r
                  ? "أنت لم تقم بتقصير أي رابط لعروضك بعد. يرجى استخدام أداة تقصير الرابط لخلق رابطك المخصص لعروضك لتتمكن من تحميل ملف ZIP."
                  : "You haven't shortened any links for your deals yet. Please use the Shorten Link tool to create your custom shortened link before downloading the ZIP file.",
              }),
              e.jsxs("button", {
                onClick: () => {
                  S(!1);
                  const t = document.querySelector(
                    'input[placeholder*="Paste"]',
                  );
                  t &&
                    (t.scrollIntoView({ behavior: "smooth", block: "center" }),
                    t.focus());
                },
                className:
                  "w-full py-2.5 px-4 bg-purple-600 hover:bg-purple-500 text-white font-black text-xs rounded-xl shadow-lg transition-all cursor-pointer flex items-center justify-center gap-2",
                children: [
                  e.jsx(J, { size: 16 }),
                  e.jsx("span", {
                    children: r
                      ? "فهمت، سأقوم بتقصير رابط الآن"
                      : "Got it, I'll shorten a link now",
                  }),
                ],
              }),
            ],
          }),
        }),
    ],
  });
}
export { ke as default };
